module.exports = __webpack_public_path__ + "static/media/walkMidGround.b3bc42fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Walk/walkMidGround.svg
// module id = 916
// module chunks = 0